import ReadableBasicInput from './ReadableBasicInput';

export default ReadableBasicInput;